// @flow

import { type Country } from '@tectonics/prs/country';
import { type PaymentSpec } from './types';
import type { IncomingPayment } from '@tectonics/prs/incoming-payment';

export function getCountry(spec: PaymentSpec|IncomingPayment): Country {
  return spec.country;
}
